/**
 * 未割当ピンの寸法と画像。V3Plans と同じものを使う
 * (V3Plans/presenters/PlanningMapOrderMarker.presenter.tsx:30-34)。
 *
 * 14px の丸を自前で描いていたが、クラスターが解けた後にどこにあるか分からないという
 * 指摘があった。旧地図と同じピンなら、画面をまたいでも同じ見え方になる。
 */
export const UNASSIGNED_PIN = {
  iconUrl: '/static/images/markers/red.png',
  iconSize: [24, 42],
  iconAnchor: [12, 42],
  tooltipAnchor: [-12, -42],
} as const;

/**
 * 未選択マーカーの不透明度。
 *
 * 番号が読める濃さに留める。以前 0.15 まで落として「全体の配置が読み取れない」と
 * 廃止した経緯があるので、そこまでは落とさない。
 */
export const UNSELECTED_MARKER_OPACITY = 0.45;

/**
 * マーカーの不透明度。
 *
 * 選択中と未選択が同じ濃さだと、どれを選んでいるか分かりにくい（指摘 2-4）。
 * 未選択は薄くするが、番号が読める濃さ (UNSELECTED_MARKER_OPACITY) に留める。
 *
 * Why not 選択が無いときも薄くする: 選んでいないうちは差を示す必要が無く、
 * 画面を開いた直後に地図全体が薄いだけになる。
 */
export function markerOpacity({ hasSelection, isSelected }: { hasSelection: boolean; isSelected: boolean }): number {
  if (!hasSelection || isSelected) return 1;
  return UNSELECTED_MARKER_OPACITY;
}
